import { Fragment } from "react";
import InputComponent from "../../components/input";
import ButtonComponent from "../../components/button";
import { useFormik } from "formik";
// import { useNavigate } from "react-router";
import { changePasswordSchema } from "../../helpers/schemas";
import { useDispatch, useSelector } from "react-redux";
import { putChangeUserPassword } from "../../redux/slices/auth-slice";
import styled from "styled-components";
import { AuthPageContainer, AuthPageHead } from "../../styles/global-styles";

const ChangePasswordMain = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Form = styled.form`
    width: 100%;
    max-width: 400px;
    background-color: var(--theme-color-secondary);
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 1rem;
    padding: 20px;
`;

const FormActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
`;

const FormError = styled.p`
    color: var(--color-error);
    font-size: 11px;
    margin: 2px 0 0 0;
`;

const ChangePassowrd = () => {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);

    const initialValues = {
        password: '',
        newPassword: '',
        confirmPassword: '',
    };

    const { handleChange, handleBlur, handleSubmit, values, touched, errors } = useFormik({
        initialValues: initialValues,
        validationSchema: changePasswordSchema,
        onSubmit: (e) => {
            dispatch(putChangeUserPassword({ user, body: e }));
        }
    });

    const fields = [
        {
            label: 'Old password',
            type: 'password',
            placeholder: 'Enter old password',
            name: 'password',
            value: values.password,
        },
        {
            label: 'New password',
            type: 'password',
            placeholder: 'Enter new password',
            name: 'newPassword',
            value: values.newPassword,
        },
        {
            label: 'Confirm new password',
            type: 'password',
            placeholder: 'Enter new password again',
            name: 'confirmPassword',
            value: values.confirmPassword,
        },
        {
            type: 'action',
            actions: [
                ...(user?.firstLogin ? [] : [{ label: 'Go Back', type: 'button', outline: true, action: () => { window.history.back() } }]),
                { label: 'Submit', type: 'submit' }
            ],
        }
    ];

    return (
        <AuthPageContainer>
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <h1>Change Password</h1>
                </div>
            </AuthPageHead>

            {/* PAGE CONTENT */}
            <ChangePasswordMain>
                <Form className="box-shadow" onSubmit={handleSubmit}>
                    {
                        fields && fields.length > 0 && fields.map((field, index) => (
                            <Fragment key={index}>
                                {
                                    ['text', 'number', 'email', 'password'].includes(field.type) &&
                                    <div>
                                        {/* <label>{field.label}</label> */}
                                        <InputComponent
                                            label={field.label}
                                            type={field.type}
                                            placeholder={field.placeholder}
                                            onBlur={handleBlur}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            mui
                                        />
                                        {
                                            touched[field.name] && errors[field.name] && (
                                                <FormError>{errors[field.name]}</FormError>
                                            )
                                        }
                                    </div>
                                }
                                {
                                    field.type === 'action' && field.actions.length > 0 &&
                                    <FormActions>
                                        {
                                            field.actions.map((button, index) => (
                                                <ButtonComponent key={index} label={button.label} type={button.type} outline={button.outline} onClick={button.action} />
                                            ))
                                        }
                                    </FormActions>
                                }
                            </Fragment>
                        ))
                    }
                </Form>
            </ChangePasswordMain>
        </AuthPageContainer>
    );
};

export default ChangePassowrd;